import "./payslip.less";

import { PaymentEditorModel } from "./editor/PaymentEditorModel";
import { paymentGroupInstanceTypes } from "./PaymentGroupModel";

/**
 * @typedef { import('./PayslipModel').PayslipModel } PayslipModel
 * @typedef { import('./PaymentModel').PaymentModel } PaymentModel
 * @typedef { import('./PaymentGroupModel').PaymentGroupModel } PaymentGroupModel
 * @typedef { import('./PaymentLock').PaymentLock } PaymentLock
 * @typedef { import('../objects/Claim').Claim } Claim
 */

class PayslipComponentController {
    static $inject = ['dialogService'];

    constructor(dialogService) {
        this._dialogService = dialogService;

        /** @type {PayslipModel} */
        this.model = null;
        /** @type {PaymentLock} */
        this.paymentLock = null;
        /** @type {PaymentEditorModel}*/
        this.editing = null;
    }

    $onChanges(changed) {
        if (changed.model) {
            this.closeEdit();

            if (this.model) {
                this.attendance = this.model.attendance;
                this.mission = this.attendance.Mission;
                this.person = this.attendance.getPerson();
                this.missionType = this.attendance.getMissionType();
                this.organization = this.attendance.getOrganization();
            } else {
                this.attendance = null;
                this.mission = null;
                this.person = null;
                this.missionType = null;
                this.organization = null;
            }
        }
    }

    $onDestroy() {
        this.closeEdit();
    }

    isLocked() {
        return this.paymentLock != null && this.paymentLock.isLocked;
    }

    showCeremonyInfo() {
        if (this.model.attendance.CeremonyId) {
            this._dialogService.showCeremony(this.model.attendance.CeremonyId);
        }
    }

    showTimeReportInfo() {
        if (this.model.hasTimeReportInfo) {
            this._dialogService.showAttendanceTimeReport(this.model.attendance);
        }
    }

    isLockTarget() {
        return this.paymentLock.isLockedForPayslip(this.model);
    }

    addPayment() {
        this.adding = PaymentEditorModel.createNew(this.paymentLock, this.model);
    }

    closeEdit() {
        if (this.adding != null) {
            this.adding = null;
            this.paymentLock.reset();
        }
    }

    /**
     * Classes that need to be on the container ('payment-group') and not on the component itself
     * @param {PaymentGroupModel} pg
     */
    getPaymentGroupClass(pg) {
        let ret = '';
        if (this.paymentLock.isLockedForGroup(pg)) {
            ret = 'payment-group--editing ';
        }

        switch (pg.paymentGroupInstanceType) {
            case paymentGroupInstanceTypes.proposedClaim:
            case paymentGroupInstanceTypes.proposedTime:
            case paymentGroupInstanceTypes.complex:
                ret += 'payment-group--bordered ';
                break;
        }

        if (pg.isCollapsable) {
            ret += 'payment-group--collapsable ';
        }

        return ret;
    }
}

angular.module("tromanWeb").component('ergoPayslip', {
    template: require('./payslip.html'),
    bindings: {
        model: '<',
        wageTypes: '<',
        paymentLock: '<',
    },
    controller: PayslipComponentController
});
